
export const ADULTS = 'adults';
export const CHILDREN = 'children';
export const INFANTS = 'infants';